import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useRemoveUser = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => api.users.removeUser(id, data),
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при удалении пользователя',
        description: err.response?.data?.message || err.message,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
    },
  })
}
